import { SET_THEME } from '../../actions'

const initialTheme = 'oxford'

export default (state = initialTheme, action) => {
  switch (action.type) {
    case SET_THEME:
      return action.payload
    default:
      return state
  }
}

export const setTheme = (theme) => (
  {
    type: SET_THEME,
    payload: theme
  }
)



// WEBPACK FOOTER //
// ./src/redux/modules/theme/index.js